import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AddSingleMemberDropdown from '../../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import Select from '../../../components/ReactSelectDropdown';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../../components/Search/SearchWithButton';
import {
  FilterLabel,
  InputWithLabelSection,
} from '../../../styledComponents/common';
import { FilterContainer } from '../../../styledComponents/tasks';

const ComplaintsFilter = ({
  publicZoneList,
  getPublicZoneList,
  officesShortList,
  getOfficesShortList,
  getComplaintsList,
  selectedOrganization,
  organizationMembersList,
  getOrganizationMembersList,
  setSelectedParams,
  selectedParams,
}) => {
  const { t } = useTranslation();
  // select last 7 days
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment(new Date()).subtract(7, 'days'),
    endDate: moment(new Date()),
  });
  const [dateUpdated, setDateUpdated] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState({
    label: t('all_status'),
    value: null,
  });
  const [selectedPublicZone, setSelectedPublicZone] = useState({
    label: t('all_public_zones'),
    value: null,
  });
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedMember, setSelectedMember] = useState('');
  const [publicZoneOptions, setPublicZoneOptions] = useState([
    {
      label: t('all_public_zones'),
      value: null,
    },
  ]);
  const [officeOptions, setOfficeOptions] = useState([
    {
      label: t('all_offices'),
      value: null,
    },
  ]);
  useEffect(() => {
    getPublicZoneList && getPublicZoneList();
  }, []);
  useEffect(() => {
    if (selectedPublicZone?.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    } else getOfficesShortList();
  }, [selectedPublicZone]);
  useEffect(() => {
    if (officesShortList && officesShortList.length === 1) {
      getOrganizationMembersList({ office_id: officesShortList[0].id });
    }
    if (officesShortList && officesShortList.length >= 1) {
      let newArr = [
        {
          label: t('all_offices'),
          value: null,
        },
      ];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      const checkSelectedOffice = newArr.find(
        office => office.value === selectedOffice?.value,
      );

      if (!checkSelectedOffice) {
        handleOfficeChange({
          label: t('all_offices'),
          value: null,
        });
      }
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);
  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [
        {
          label: t('all_public_zones'),
          value: null,
        },
      ];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);
  useEffect(() => {
    selectedOrganization?.id && callGetComplaintsList();
  }, [
    dateUpdated,
    selectedStatus,
    currentSearchTerm,
    selectedPublicZone,
    selectedOffice,
    selectedOrganization,
    selectedMember,
  ]);
  useEffect(() => {
    if (selectedOrganization?.id) {
      const payload = {
        organization_id: selectedOrganization.id,
      };
      if (selectedOffice?.value) {
        payload.office_id = selectedOffice.value;
      }
      getOrganizationMembersList(payload);
    }
  }, [selectedOrganization, selectedOffice]);

  const callGetComplaintsList = () => {
    const payload = {};

    if (selectedDate.startDate && selectedDate.endDate) {
      payload.start = selectedDate.startDate.format('YYYY-MM-DD');
      payload.end = selectedDate.endDate.format('YYYY-MM-DD');
    }
    if (selectedStatus.value) {
      payload.status = selectedStatus.value;
    }
    if (currentSearchTerm) {
      payload.complaints_no = currentSearchTerm;
    }
    if (selectedPublicZone.value) {
      payload.public_zone_id = selectedPublicZone.value;
    }
    if (selectedOffice?.value) {
      payload.office_id = selectedOffice.value;
    }
    if (selectedMember?.id) {
      payload.created_by = selectedMember.id;
    }

    // Update the selectedParams for export functionality
    setSelectedParams && setSelectedParams(payload);

    getComplaintsList(payload);
  };

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleSearchByRequestNo = () => {
    setCurrentSearchTerm(searchTerm);
  };

  const handleClearSearch = () => {
    setCurrentSearchTerm('');
    setSearchTerm('');
  };

  const handlePublicZoneChange = e => {
    setSelectedPublicZone(e);
  };

  const handleOfficeChange = e => {
    setSelectedOffice(e);
  };

  const selectMember = person => {
    setSelectedMember(person);
  };

  const clearMember = () => {
    setSelectedMember('');
  };

  const onMemberSelect = person => {
    selectMember(person);
  };

  const clearSelectedMember = () => {
    clearMember();
  };

  return (
    <FilterContainer marginTop="30px">
      <SearchWithButton
        itemName=""
        label={t('complaint_no')}
        searchTermName={t('complaint_no')}
        searchInput={searchTerm}
        onInputChange={e => setSearchTerm(e.target.value)}
        handleSearch={handleSearchByRequestNo}
        handleClearSearch={handleClearSearch}
      />
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('public_zone')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedPublicZone}
          options={publicZoneOptions}
          placeholder={t('select_public_zone')}
          onChange={handlePublicZoneChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection width="200px">
        <FilterLabel>{t('office')}</FilterLabel>
        <Select
          isSearchable={false}
          value={selectedOffice}
          options={officeOptions}
          placeholder={t('select_office')}
          onChange={handleOfficeChange}
          styles={CreateProjectDropdown()}
          filterOption={filterOption}
        />
      </InputWithLabelSection>
      <InputWithLabelSection>
        <FilterLabel>{t('reporter')}</FilterLabel>
        <div style={{ width: `40px` }}>
          <AddSingleMemberDropdown
            assigneeManage={selectedMember}
            updateState={onMemberSelect}
            membersList={organizationMembersList}
            clearAssignee={clearSelectedMember}
          />
        </div>
      </InputWithLabelSection>
      <InputWithLabelSection width="max-content">
        <FilterLabel>{t('date_range')}</FilterLabel>
        <ReactDateRangePicker
          startDate={selectedDate.startDate}
          startDateId="complaints-start-date"
          endDate={selectedDate.endDate}
          endDateId="complaints-end-date"
          onDatesChange={handleDateChange}
          onDateSelect={() => setDateUpdated(!dateUpdated)}
          dateDisplayFormat="DD/MM/YYYY"
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default ComplaintsFilter;
